import React from "react"
import {
  CheckboxYesNo,
  FormContainer,
  formatCurrency,
  LabeledInput,
  DatePicker,
  Worksheet
} from "uikit"
import { Dropdown, Input } from "semantic-ui-react"
import { paymentFrequencyOptions } from "../../dropDownOptions"
import { Footer } from "./Footer"
import { PAY_FREQUENCY_DIVISOR } from "components/incomes/dropDownOptions"

const AlimonyForm = ({
  data: {
    fields: {
      description,
      is_pre2019,
      is_taxable,
      payment_amount,
      pay_frequency,
      until_date
    },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  onDelete,
  isNew
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row
          label={"Description of income"}
          paddedField
          description={`You can enter the name of the payer or another label.`}
        >
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Was the agreement made before Jan. 1, 2019?"
          description={
            <>
              Beginning Jan. 1, 2019, alimony or separation maintenance payments
              are not deductible from the income of the payer spouse, or
              includable in the income of the receiving spouse, if made under a
              divorce or separation agreement executed after Dec. 31, 2018.
            </>
          }
          paddedField
        >
          <Worksheet.Field>
            <CheckboxYesNo fluid {...is_pre2019} />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Are these payments taxable?"
          paddedField
          description="This is commonly the case if the agreement was finalized before 2019."
        >
          <Worksheet.Field>
            <CheckboxYesNo fluid {...is_taxable} />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="What is the pre-tax payment amount?" paddedField>
          <Worksheet.Field error={payment_amount.error}>
            <LabeledInput
              {...payment_amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="How frequently is it paid?" paddedField>
          <Worksheet.Field error={pay_frequency.error}>
            <Dropdown
              placeholder="Frequency"
              selection
              options={paymentFrequencyOptions}
              data-testid="pay_frequency"
              {...pay_frequency}
            />
            {payment_amount.value && pay_frequency.value && (
              <span style={{ fontWeight: "normal" }}>
                Approximately{" "}
                {formatCurrency(
                  Math.floor(
                    payment_amount.object *
                      PAY_FREQUENCY_DIVISOR[pay_frequency.object]
                  )
                )}{" "}
                per year
              </span>
            )}
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="Until when will the alimony be paid?" paddedField>
          <Worksheet.Field error={until_date.error}>
            <DatePicker {...until_date} />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Income"
        error={error}
      />
    </Worksheet>
  )
}

const AlimonyFormContainer = FormContainer(
  {
    description: {
      type: "string"
    },
    is_pre2019: {
      type: "boolean",
      defaultValue: "false"
    },
    is_taxable: {
      type: "boolean",
      defaultValue: "false"
    },
    payment_amount: {
      type: "unit"
    },
    pay_frequency: {
      type: "string",
      defaultValue: "biweekly"
    },
    until_date: {
      type: "date",
      minValue: new Date(),
      maxValue: new Date(new Date().getFullYear() + 75, 0, 1)
    },
    type: {
      type: "string",
      defaultValue: "alimony"
    }
  },
  (fields, ...form) => {}
)(AlimonyForm)

const Alimony = ({ isNew, income, ...formProps }) => {
  const values = isNew ? {} : income
  return (
    <AlimonyFormContainer
      {...{
        values,
        ...formProps
      }}
    />
  )
}

export default Alimony
